import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BottomPopupService } from '../services/bottom-popup.service';
import { StoreService } from '../services/store.service';

@Injectable({
	providedIn: 'root',
})
export class CanLeaveTeudaPageGuard implements CanDeactivate<unknown> {
	private _ss = inject(StoreService);
	private router = inject(Router);
	private _bottomPopup = inject(BottomPopupService);
	constructor() {}
	canDeactivate(
		component: unknown,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this._ss.canLeaveTeudaPage) {
			this.router.navigate([currentState.url.slice(1)]);
			this._bottomPopup.show('לא ניתן לעזוב את הדף לפני סיום שליחת תעודה');
		}
		return this._ss.canLeaveTeudaPage;
	}
}
